module.exports = __webpack_public_path__ + "static/media/mingxia.3886327e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/mingxia.png
 ** module id = 463
 ** module chunks = 0
 **/